import { render, staticRenderFns } from "./Direct.vue?vue&type=template&id=49a3c0c8&scoped=true&"
import script from "./Direct.vue?vue&type=script&lang=js&"
export * from "./Direct.vue?vue&type=script&lang=js&"
import style0 from "./Direct.vue?vue&type=style&index=0&id=49a3c0c8&prod&lang=css&"
import style1 from "./Direct.vue?vue&type=style&index=1&id=49a3c0c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a3c0c8",
  null
  
)

export default component.exports